module.exports = __webpack_public_path__ + "img/voyage.969b1f3f.jpeg";